//--------------------------------------------------------------------//
//******************** trunkShortCodeTab ********************************//
//--------------------------------------------------------------------//
// Lets a trunk owner/admin place a one-off call through the trunk to a
// provider-required short code (e.g. Zadarma verifies a trunk by having it
// call 8888 - see docs/sip-trunks/send-short-code.md). The response is
// always shown verbatim (FreeSWITCH's raw +OK/-ERR text), not just a
// generic confirmation, since success here only means FreeSWITCH placed
// the call - the provider's own verification happens on their side.
import trunkShortCodeTemplateUrl from './trunk-short-code.template.html';

angular.module('sipTrunksTableModule')

.directive('trunkShortCodeTab', ['SipTrunksService', 'GhDialog', function (SipTrunksService, GhDialog) {
    return {
        restrict: 'E',
        scope: {
            trunk: '=',
            onUpdate: '&'
        },
        controller: ['$scope', 'localizationService', function ($scope, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);

            $scope.number = '8888';
            $scope.sending = false;
            $scope.lastResult = null;

            const safeApply = function () {
                $scope.$applyAsync();
            };

            function showError(message) {
                GhDialog.show({
                    position: 'center',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        resizable: false,
                        content: `
                            <div class="delete_sip_trunk-popup">
                                <div class="dialog-share-group">
                                    <p class="dialog-share-group__title">Error</p>
                                </div>
                                <div class="dialog-share-group__content">
                                    <p class="info">{{errorMessage}}</p>
                                    <div class="dialog-share-group__content__buttons">
                                        <button class="btn btn-blue" ng-click="cancel()">OK</button>
                                    </div>
                                </div>
                            </div>
                        `
                    },
                    locals: { errorMessage: message },
                    controller: ['$scope', 'errorMessage', function ($scope, errorMessage) {
                        $scope.errorMessage = errorMessage;
                    }]
                });
            }

            $scope.send = async function () {
                const number = ($scope.number || '').trim();
                if (!number || !$scope.trunk.enabled) return;

                $scope.sending = true;
                $scope.lastResult = null;

                try {
                    $scope.lastResult = await SipTrunksService.sendShortCode($scope.trunk.trunk_id, number);
                } catch (error) {
                    console.log('Send short code error:', error);
                    showError(error.message || 'Failed to send short code');
                } finally {
                    $scope.sending = false;
                    safeApply();
                }
            };
        }],
        templateUrl: trunkShortCodeTemplateUrl
    };
}]);
